export default __webpack_public_path__ + "static/media/bg_pub.b83f6772.svg";